/* global grecaptcha */
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    callbackName: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    siteKey: PropTypes.string.isRequired,
    className: PropTypes.string,
    verifyCallback: PropTypes.func,
    expiredCallback: PropTypes.func,
    errorCallback: PropTypes.func,
    theme: PropTypes.oneOf(['light', 'dark']),
    size: PropTypes.oneOf(['normal', 'compact'])
};

function ReCaptcha(props) {
    const {
        id,
        callbackName,
        className = '',
        siteKey,
        verifyCallback,
        expiredCallback,
        errorCallback,
        theme,
        size
    } = props;

    const onLoadCallback = useCallback(() => {
        grecaptcha.render(id, {
            'sitekey': siteKey,
            'callback': verifyCallback,
            'expired-callback': expiredCallback,
            'error-callback': errorCallback,
            theme,
            size
        });
    }, [id, siteKey, verifyCallback, expiredCallback, errorCallback, theme, size]);

    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (callbackName && typeof window[callbackName] === 'undefined') {
            window[callbackName] = onLoadCallback;

            return () => {
                delete window[callbackName];
            };
        }
    }, [callbackName, onLoadCallback]);

    return (
        <div className="asc-form-group ul-recaptcha-container">
            <div id={id} className={`ul-recaptcha ${className}`} />
        </div>
    );
}

ReCaptcha.propTypes = propTypes;
export default ReCaptcha;
